import { defineStore } from 'pinia';
import { computed, type ComputedRef } from 'vue';
import { useCartCheckoutStore } from '@white-label-store/cart-checkout';
import { isGtm1216PriorityPassLoungesCollinsonIntegrationEnabled } from '@white-label-plugin/launch-darkly';
import type {
  CartItem,
} from '@white-label-types/parking-checkout';

export const useLoungePassStore = defineStore('loungePass', () => {

  const loungePassItem: ComputedRef<CartItem | undefined> = computed(() => {
    const cartCheckoutStore = useCartCheckoutStore();
    const checkoutCartItems = cartCheckoutStore.readCartItems;
    return checkoutCartItems.find((cartItem) => {
      const isCheckoutFieldAdditionalTravellerNamesEnabled = !Array.isArray(cartItem.inventory_item.additional_fields) && cartItem.inventory_item.additional_fields['additional_passengers'] ? cartItem.inventory_item.additional_fields['additional_passengers'].is_show === true : false;
      return isCheckoutFieldAdditionalTravellerNamesEnabled;
    });
  });

  const hasLoungePassItem = computed(() => {
    return Boolean(isGtm1216PriorityPassLoungesCollinsonIntegrationEnabled() && loungePassItem.value);
  });
  const hasAdditionalTravellers = computed(() => {
    return isGtm1216PriorityPassLoungesCollinsonIntegrationEnabled() && loungePassItem.value ? loungePassItem.value.quantity > 1 : false;
  });

  const displayLoungePassAdditionalTravellers = computed(() => {
    return isGtm1216PriorityPassLoungesCollinsonIntegrationEnabled() && hasAdditionalTravellers.value;
  });

  const isLoungePassAdditionalTravellersDetailsRequired = computed(() => {
    if (!loungePassItem.value) return false;
    return loungePassItem.value.inventory_item.additional_fields
    && loungePassItem.value.inventory_item.additional_fields['additional_passengers']
    && loungePassItem.value.inventory_item.additional_fields['additional_passengers'].is_required === true;
  });

  return {
    loungePassItem,
    hasLoungePassItem,
    hasAdditionalTravellers,
    displayLoungePassAdditionalTravellers,
    isLoungePassAdditionalTravellersDetailsRequired,
  };
}, {
  persist: true,
});
